import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, injectIntl, intlShape } from '../../../../util/reactIntl';
import * as validators from '../../../../util/validators';
import { Form, PrimaryButton, FieldPasswordInput } from '../../../../components';

import css from '../SignupWizard.module.css';

const PasswordStepComponent = props => {
  const {
    formData,
    onSubmit,
    inProgress,
    intl,
  } = props;

  return (
    <FinalForm
      initialValues={{ password: formData.password }}
      onSubmit={values => onSubmit(values)}
      render={fieldRenderProps => {
        const { handleSubmit, invalid, submitting } = fieldRenderProps;

        const passwordLabel = intl.formatMessage({ id: 'SignupWizard.passwordLabel' });
        const passwordPlaceholder = intl.formatMessage({ id: 'SignupWizard.passwordPlaceholder' });
        const passwordRequiredMessage = intl.formatMessage({ id: 'SignupForm.passwordRequired' });
        const passwordMinLengthMessage = intl.formatMessage(
          { id: 'SignupForm.passwordTooShort' },
          { minLength: validators.PASSWORD_MIN_LENGTH }
        );
        const passwordMaxLengthMessage = intl.formatMessage(
          { id: 'SignupForm.passwordTooLong' },
          { maxLength: validators.PASSWORD_MAX_LENGTH }
        );

        const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);
        const passwordMinLength = validators.minLength(
          passwordMinLengthMessage,
          validators.PASSWORD_MIN_LENGTH
        );
        const passwordMaxLength = validators.maxLength(
          passwordMaxLengthMessage,
          validators.PASSWORD_MAX_LENGTH
        );
        const passwordValidators = validators.composeValidators(
          passwordRequired,
          passwordMinLength,
          passwordMaxLength
        );

        const submitDisabled = invalid || submitting || inProgress;

        return (
          <Form className={css.stepForm} onSubmit={handleSubmit}>
            <FieldPasswordInput
              className={css.field}
              id="password"
              name="password"
              autoComplete="new-password"
              label={passwordLabel}
              placeholder={passwordPlaceholder}
              validate={passwordValidators}
            />

            <div className={css.bottomWrapper}>
              <PrimaryButton type="submit" inProgress={inProgress} disabled={submitDisabled}>
                <FormattedMessage id="SignupWizard.nextButton" />
              </PrimaryButton>
            </div>
          </Form>
        );
      }}
    />
  );
};

PasswordStepComponent.defaultProps = {
  inProgress: false,
};

PasswordStepComponent.propTypes = {
  formData: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  inProgress: PropTypes.bool,
  intl: intlShape.isRequired,
};

const PasswordStep = compose(injectIntl)(PasswordStepComponent);

export default PasswordStep;
